module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp3_0.e2293cef.png";